let recaptchaPromise = null;

function loadRecaptchaScript(siteKey) {
  if (recaptchaPromise) return recaptchaPromise;

  recaptchaPromise = new Promise((resolve, reject) => {
    if (window.grecaptcha && typeof window.grecaptcha.execute === "function") {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load reCAPTCHA"));

    document.head.appendChild(script);
  });

  return recaptchaPromise;
}

export default function newsletter({ siteKey }) {
  return {
    // derived from <form action>
    actionUrl: "",

    // client-owned copy only
    messages: {},

    // state
    status: "idle", // idle | submitting | success | error
    message: "",

    // form fields
    fullname: "",
    email: "",

    // reCAPTCHA
    recaptchaLoaded: false,

    init() {
      this.actionUrl = this.$el.getAttribute("action") || "";

      this.messages = {
        required:
          this.$el.dataset.msgRequired ||
          "Email address is required.",

        clientError:
          this.$el.dataset.msgClientError ||
          "Unable to subscribe at this time.",
      };
    },

    // called via Alpine event modifiers in markup
    loadRecaptcha() {
      if (this.recaptchaLoaded) return;
      this.recaptchaLoaded = true;

      loadRecaptchaScript(siteKey).catch(() => {});
    },

    async submit() {
      if (this.status === "submitting") return;

      this.message = "";
      this.status = "idle";

      // client-side validation
      if (!this.email) {
        this.status = "error";
        this.message = this.messages.required;
        return;
      }

      if (!this.actionUrl) {
        this.status = "error";
        this.message = this.messages.clientError;
        return;
      }

      this.status = "submitting";

      try {
        // ensure script is loaded even if no prior interaction
        await loadRecaptchaScript(siteKey);

        if (!window.grecaptcha || typeof window.grecaptcha.execute !== "function") {
          throw new Error("reCAPTCHA unavailable");
        }

        const token = await window.grecaptcha.execute(siteKey, {
          action: "newsletter_signup",
        });

        await this.post(token);
      } catch (e) {
        this.status = "error";
        this.message = this.messages.clientError;
      }
    },

    async post(token) {
      try {
        const fd = new FormData();
        fd.set("fullname", this.fullname);
        fd.set("email", this.email);
        fd.set("g-recaptcha-response", token);

        const res = await fetch(this.actionUrl, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: fd,
          credentials: "same-origin",
        });

        const data = await res.json();

        if (!res.ok || !data?.success) {
          this.status = "error";
          this.message = data?.error || this.messages.clientError;
          return;
        }

        this.status = "success";
        this.message = data?.message || "";
        this.fullname = "";
        this.email = "";
      } catch (e) {
        this.status = "error";
        this.message = this.messages.clientError;
      }
    },
  };
}
